export default __webpack_public_path__ + "static/media/Bangles.107097ae.jpg";